import React from 'react';
import { FETCH_PARAMETRESFORM_FAILURE, FETCH_PARAMETRESFORM_REQUEST, FETCH_PARAMETRESFORM_SUCCESS } from '../Types';
import { notification } from 'antd';
import { DcOffLineHost } from "../../config";

export const ListParametrageFormActions = (formId) => {

    
    return async (dispatch) => {
            dispatch({type:FETCH_PARAMETRESFORM_REQUEST});

             try {
                  const token = localStorage.getItem("token");
    
                  if (!token) {
                      throw new Error("Aucun token trouvé, veuillez vous reconnecter.");
                  }
    
                const response = await fetch(`${DcOffLineHost}api/formsettings/${formId}`, {
                                method: "GET", 
                                headers: {
                                    "Content-Type": "application/json",
                                    "Authorization": `Bearer ${token}`, 
                                },
                            });
                
               const data = await response.json();
                if (!response.ok) {
                    throw new Error(data?.message || "Erreur lors de la récupération des paramètres du formulaire");
                }
               
                dispatch({ type: FETCH_PARAMETRESFORM_SUCCESS, payload: data });
                return data;

                } catch (error) {
                dispatch({ type: FETCH_PARAMETRESFORM_FAILURE, payload: error?.message });

                notification.error({
                    message:error?.message || "Erreur lors de la récupération des paramètres du formulaire",
                    duration: 5,
                });
                }
                }
};
